exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".subscribe-and-save .hero-product[data-v-387c28b6] {\n  padding: 0 1.5em 2em;\n}\n.subscribe-and-save .section-title[data-v-387c28b6] {\n  padding: 1em;\n}\n@media mobile {\n.subscribe-and-save .hero-product[data-v-387c28b6] {\n    padding: 0 0 2em;\n}\n}\n", ""]);

// exports
